import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import {DateHelpers} from '../../../../../../helpers/date-helpers';
import LinkBuilder from '../../../../../../helpers/link-builder';

const TypeCandidateApplication = props => {
  const {
    post: {
      ProcessID,
      ProcessType,
      FirmName,
      FirmUrlAlias,
      FirmActive,
      currentSchoolName,
      Count,
      NewsFeedDateAdd,
      Date,
      PositionTitle,
    },
    options: { hideProcessLink },
    actions: { checkPermissions },
  } = props;

  const handleClickProfileLink = e => {
    if (!checkPermissions()) {
      e.preventDefault();
    }
  };

  const link = hideProcessLink
    ? '#'
    : ProcessType === 'Job'
    ? LinkBuilder.getJobLink(ProcessID)
    : LinkBuilder.getProjectLink(ProcessID);

  const firmLink = FirmUrlAlias ? (
    FirmActive === 'Yes' ? (
      <NavLink to={LinkBuilder.getFirmLink(FirmUrlAlias)}>{FirmName}</NavLink>
    ) : (
      <span className="feed-post-content__span">{FirmName}</span>
    )
  ) : (
    currentSchoolName && (
      <span className="feed-post-content__span">{currentSchoolName}</span>
    )
  );

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        <div className="feed-post-content__text" style={{ marginLeft: '0' }}>
          <strong>
            {parseInt(Count) >= 5 ? Count : ''}
            {parseInt(Count) < 5 ? 'Candidates ' : ' candidates '}
            applied
          </strong>{' '}
          to
        </div>
        <NavLink
          className="feed-post-content__postition"
          to={link}
          onClick={handleClickProfileLink}
        >
          {PositionTitle}
        </NavLink>
        <div className="feed-post-content__text">job by</div>
        {firmLink}
        <div className="feed-post-content__text">today</div>
      </div>
      <div className="feed-post-content__date">{date}</div>
    </div>
  );
};

export default TypeCandidateApplication;
